import { render } from "./ItemManageBranchForm.vue?vue&type=template&id=7fb822d1"
import script from "./ItemManageBranchForm.vue?vue&type=script&lang=js"
export * from "./ItemManageBranchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__